export class GenericFilter {
    startRow!: number;
    endRow!: number;
    sortCol!: string;
    sortDir!: string;
    className!: string;
    name!: string;
    sortItems!: any[];
    clientFilters!: any[];
}